import { Component, OnDestroy, OnInit } from '@angular/core';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { ProjetoCadastro } from '../../models/projeto-cadastro.model';
import { SgoProjeto } from '../../models/sgo-projeto.model';
import { PesquisaGeralService } from '../../services/pesquisa-geral.service';
import { SgoProjetoService } from '../../services/sgo-projeto.service';

@Component({
  selector: 'app-detalhe-projeto-sgo-list',
  templateUrl: './detalhe-projeto-sgo-list.component.html',
  styleUrls: ['./detalhe-projeto-sgo-list.component.scss']
})
export class DetalheProjetoSgoListComponent extends BaseListComponent<SgoProjeto> implements OnInit, OnDestroy {

  idProjeto: number;
  infoProjeto: ProjetoCadastro;
  isCollapsed: boolean;
  sgoList: SgoProjeto[];

  constructor(
    private myService: SgoProjetoService,
    private pesquisaGeralService: PesquisaGeralService,
  ) {
    super();
  }

  ngOnInit() {
    this.pesquisaGeralService.info.subscribe(info => {
      this.infoProjeto = info;
      this.idProjeto = this.infoProjeto.id;
      this.initLoadTable();
    });
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }

  initLoadTable() {
    this.addSub(
      this.myService.getListAll(this.idProjeto).subscribe((res) => {
        this.sgoList = res;
        this.loaded();
      })
    );
  }

  infoSgo(id: string, index: number, sgoIndex: number) {
    let sgoInfo = this.sgoList[index]?.sgo[sgoIndex];
    if (!sgoInfo.info) {
      this.loading();
      this.addSub(
        this.myService.getInfoSgo(id).subscribe({
          next: (res) => {
            if (sgoInfo) {
              sgoInfo.info = res;
            }
            sgoInfo.isCollapsed = true;
            this.loaded();
          },
          error: (err) => {
            this.loaded();
            this.msgError(err?.error?.message);
          },
        })
      )
    } else {
      sgoInfo.isCollapsed = !sgoInfo.isCollapsed;
    }
  }

}
